import { type HeaderGroup, type SortDirection } from "@tanstack/react-table"
import classNames from "classnames"
import { Icon } from "../Icon"

interface Props<T> {
  headerGroup: HeaderGroup<T>
}

function getSortIcon(sortDirection: SortDirection | false) {
  if (sortDirection === "asc") {
    return <Icon variant="ArrowUp" size="xs" />
  } else if (sortDirection === "desc") {
    return <Icon variant="ArrowDown" size="xs" />
  }

  return <Icon variant="ChevronDown" size="xs" />
}

export function ReferralTableHeader<T>({ headerGroup }: Props<T>) {
  return (
    <tr key={headerGroup.id}>
      {headerGroup.headers.map((header) => (
        <th key={header.id} colSpan={header.colSpan}>
          {header.isPlaceholder ? null : (
            <div
              className={classNames("pl-6 flex items-center justify-start", {
                "cursor-pointer select-none": header.column.getCanSort(),
                "cursor-default": !header.column.getCanSort(),
              })}
              onClick={header.column.getToggleSortingHandler()}
              onKeyDown={(e) => {
                if (e.code === "Enter") {
                  header.column.getToggleSortingHandler()?.(e)
                }
              }}
              role={header.column.getCanSort() ? "button" : undefined}
              tabIndex={header.column.getCanSort() ? 0 : undefined}
            >
              <>
                {header.renderHeader()}
                <div className="ml-3">
                  {header.column.getCanSort() &&
                    getSortIcon(header.column.getIsSorted())}
                </div>
              </>
            </div>
          )}
        </th>
      ))}
    </tr>
  )
}
